<template>
    <section v-if="categoryArticles?.length === 3"
        class="relative flex flex-col justify-center items-center sm:py-12 lg:py-16 text-center">
        <div class="h-auto my-15">
            <h2 class="font-semibold">Relevant Recent Articles</h2>
        </div>

        <div class="page-heading sm:mt-20 sm:mb-8 sm:px-28 ">
            <div class="gap-y-3 flex flex-wrap text-left">
                <Article v-for="article of categoryArticles" :key="article.path" :article="article"
                    class="w-full lg:w-1/3" />
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { type IArticle, BLOG_CARD_FIELDS } from '~/services/blog';

export default {
    props: {
        category: {
            type: String,
            required: true,
        },
    },
    async setup(props) {
        const category = props.category;
        const search: string = category === 'ads' ? 'advertising' : category === 'uc' ? 'call' : category;
        const search2: string = category === 'hris' ? 'hr' : category === 'calendar' ? 'scheduling' : '';

        // Filter and trim inside the handler so only the 3 rendered cards end up
        // in the page payload (not every post).
        const { data: categoryArticles } = await useAsyncData(`category-articles-${category}`, async () => {
            const posts = (await queryCollection('content')
                .where('path', 'LIKE', '/blog/%')
                .select(...BLOG_CARD_FIELDS)
                .order('date', 'DESC')
                .all()) as unknown as IArticle[];
            const articles = posts.filter((article) =>
                article.title?.toLowerCase().includes(` ${search}`) ||
                search2 && article.title?.toLowerCase().includes(` ${search2}`));
            articles.sort((a, b) => b.date.localeCompare(a.date));
            return articles.slice(0, 3);
        });

        return {
            categoryArticles,
        };
    },
};
</script>